export class AuthenticationError extends Error {
	public code: string;

	constructor(code: string, message: string, cause?: Error) {
		super(message, { cause: cause });
		this.code = code ?? 'ERROR_AUTHENTICATION';
	}
}
